import React from "react";
import Title from "./Title";
import click_sound from "./sounds/click.mp3";
import Help from "./Help";

import atomic_masses from "./masses.json";
import FormulaInput from "./FormulaInput";
import Periodic_table from "./Periodic_table";

import "./styles.css"

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user_formula: "",
            formula: "",
            target_molecular_mass: "",
            atoms: [],
            atoms_and_numbers: []
        };
        this.numbers = "1234567890";
    }

    change_formula = (newFormula) => {
        this.setState({ user_formula: newFormula });
        this.setState({ formula: newFormula.toLowerCase() });
        this.setState({ target_molecular_mass: this.calculate_atomic_masses(newFormula) });
    }

    formula_changed = (newFormula) => {
        //console.log(newFormula)
        this.setState({ user_formula: newFormula });
        this.setState({ formula: newFormula.toLowerCase() });
        this.setState({ atoms: [] });
        this.setState({ target_molecular_mass: this.calculate_atomic_masses(newFormula) });
    }

    //play_click_sound = useSound("sounds/click.mp3");

    add_atom = (atom) => {
        //this.play_click_sound();
        //useSound(click_sound);
        //this.play_click_sound();
        let new_atom = atom.toLowerCase();
        let last_index = this.state.atoms.length - 1;
        let the_last_atom_name = this.state.atoms[last_index];
        if (new_atom != the_last_atom_name) {
            if (this.state.formula == " " || this.state.formula == "") {
                this.change_formula(atom);
            } else {
                this.change_formula(this.state.user_formula + " " + atom);
            }
        }
        else {
            //console.log("This atom is last!");
            let last_atom = this.divide_numbers_and_atom(this.state.atoms_and_numbers[last_index]);
            let number = String(Number(last_atom[1]) + 1);
            console.log(number);
            let new_formula = ""//this.state.formula + number;
            //if (this.numbers.includes(this.state.formula[this.state.formula.length - 1])) {
            //    new_formula = this.state.formula.substring(0, -(number.length));
            //}
            //console.log(this.state.formula[this.state.formula.length - 1]);
            let last_atom_index = this.state.user_formula.length - 1;
            if (!isNaN(this.state.user_formula[last_atom_index])) {
                new_formula = this.state.user_formula.substring(0, (last_atom_index - last_atom[1].length) + 1) + number;
            } else {
                new_formula = this.state.user_formula + number;
            }
            this.change_formula(new_formula);
        }
    }

    divide_numbers_and_atom = (atom) => {
        let numberStr = ""
        let target_num = 0
        for (let char of atom) {
            if (!isNaN(char)) {
                numberStr += char;
                continue;
            }
            target_num += 1
        }
        if (numberStr == "") { numberStr = "1"; }
        let real_atom = atom.substring(0, target_num);
        //console.log(real_atom);
        return [real_atom, numberStr]
    }

    is_formula_contains_atom = (atom) => {
        let is_active = this.state.atoms.includes(atom.toLowerCase());
        //console.log(is_active);
        return is_active;
    }

    calculate_atomic_masses(new_formula) {
        let totalMass = 0;
        let formula = new_formula.toLowerCase();

        if (formula == "") { return ""; }

        let atoms = formula.split(" ");
        this.setState({ atoms_and_numbers: atoms });
        let real_atoms = [];

        for (let atom of atoms) {
            let new_atom = this.divide_numbers_and_atom(atom);
            //console.log(real_atom, numberStr);
            real_atoms.push(new_atom[0]);
            totalMass += Number(new_atom[1]) * atomic_masses[new_atom[0]];
        }
        this.setState({ atoms: real_atoms });

        if (isNaN(totalMass)) { return "?"; }
        return totalMass.toFixed(2);
    }

    render() {
        return (
            <div className="main">
                <Title />
                <div className="FormulaDiv">
                    <span className="formulaText">
                        Mr(
                        <FormulaInput
                            value={this.state.user_formula}
                            onChange={this.formula_changed}
                        />) = {this.state.target_molecular_mass}
                    </span>
                </div>
                <Periodic_table
                    callback={this.add_atom}
                    is_activate={this.is_formula_contains_atom}
                />
                <Help />
            </div>
        )
    }
}

export default App